import ApiHandler from './ApiHandler'

export default {
  updateUserRoles: data => ApiHandler.post('admin/add_role', data),
  fetch_all_roles: () => ApiHandler.get('admin/roles'),
  admin_delete_role: roleId => ApiHandler.delete(`admin/role/${roleId}`),
  updatePermissions: data => ApiHandler.put('admin/update_role', data)
}
